import { Component, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UiStateFacade, UserDataFacade } from '@ra-state';
import { IToastConfig, NotificationType, OverlayPosition, ToastDirective } from '@ra-web-tech-ui-toolkit/components';
import * as R from 'remeda';
import { tap } from 'rxjs';
import { AsyncPipe } from '@angular/common';
@Component({
  selector: 'app-snackbar',
  styleUrls: ['./snackbar.component.scss'],
  templateUrl: './snackbar.component.html',
  imports: [ToastDirective, AsyncPipe],
})
export class SnackBarComponent {
  private readonly uiStateFacade = inject(UiStateFacade);
  router = inject(Router);
  private readonly userDataFacade = inject(UserDataFacade);

  navigateTo: string;
  isRefresh: boolean = false;
  navigationOptions: {
    actionType?: string;
    targetTenantId?: string;
  };
  @ViewChild(ToastDirective, { static: true }) public toastRef: ToastDirective;
  public toastConfig: IToastConfig = {
    delay: 7000,
    position: OverlayPosition['TopRight'],
    panelClass: 'fthub-toast',
    preserveToastWhileHovering: true,
  };
  displayMessage$ = this.uiStateFacade.displayMessage$.pipe(
    tap((data) => {
      const title = data?.title ? data.title : '';
      const type = data?.type ? data?.type : 'Success';
      this.toastConfig.delay = data?.duration ?? this.toastConfig.delay;
      this.toastConfig = R.clone(this.toastConfig);
      if (data?.customBtn) {
        this.isRefresh = data.customBtn.label === 'Refresh';
        this.navigateTo = data.customBtn.navigateTo ?? '';
        this.navigationOptions = data.customBtn.navigationOptions ?? {};
        this.toastRef.buttons = [{ label: `${data.customBtn.label}` }];
        this.toastRef.addToast(data?.message, NotificationType[type], title);
      } else {
        this.toastRef.buttons = [];
        this.toastRef.addToast(String(data?.message), NotificationType[type], title);
      }
    }),
  );

  btnClick(): void {
    if (this.isRefresh) {
      window.location.reload();
    } else if (this.navigationOptions?.actionType === 'tenantChange' && this.navigationOptions.targetTenantId) {
      this.userDataFacade.tenantChange(this.navigationOptions.targetTenantId, this.navigateTo);
    } else {
      this.router.navigate([this.navigateTo]);
    }
  }
}
